import "./index.css";
import React, { useState, useRef, useEffect } from "react";
import { motion, useScroll, useSpring, useTransform, useMotionValue, useVelocity, useAnimationFrame } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { wrap } from "@motionone/utils";

function ParallaxText({ children, baseVelocity = 100 }) {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400,
  });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false,
  });

  const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);

  const directionFactor = useRef(1);
  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

    if (velocityFactor.get() < 0) {
      directionFactor.current = -1;
    } else if (velocityFactor.get() > 0) {
      directionFactor.current = 1;
    }

    moveBy += directionFactor.current * moveBy * velocityFactor.get();
    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="parallax text-4xl">
      <motion.div className="scroller" style={{ x }}>
        <span>{children} </span>
        <span>{children} </span>
        <span>{children} </span>
        <span>{children} </span>
      </motion.div>
    </div>
  );
}

export default function Parallax() {
  const textRef = useRef(null);
  const [percentage, setPercentage] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.6,
    rootMargin: "-5% 0px -20% 0px",
  });

  useEffect(() => {
    const handleScroll = () => {
      if ( inView && textRef?.current) {
        const rect = textRef.current.getBoundingClientRect();
        const adjustedViewportHeight = window.innerHeight*0.4;

       
        const scrollRangeStart = adjustedViewportHeight*0.3; // 
        const scrollRangeEnd = adjustedViewportHeight + window.innerHeight; 

        const scrollPercentage = Math.max(0, Math.min(1, (scrollRangeEnd - rect.top) / (scrollRangeEnd - scrollRangeStart))) * 100;

       
        setPercentage(scrollPercentage);
      }
    };

    if (inView) {
      window.addEventListener("scroll", handleScroll);
    } else {
      setPercentage(0); 
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inView]);

  return (
    <section style={{marginTop:'80vh'}} ref={ref}>
      <ParallaxText baseVelocity={-1}>User Experience Design Frontend User Interface Web View</ParallaxText>
      <span className="inbetween">
        Open for
        <motion.span
          ref={textRef}
          className="gradient-text "
          style={{
            backgroundPositionX: `${-percentage}%`,
            marginLeft: 10,
          }}
        >
          Collaboration
        </motion.span>
        
      </span>

      <ParallaxText baseVelocity={1}>Frontend Design Fullstack Backend Architecture Scalability</ParallaxText>
    </section>
  );
}
